import React from 'react';
import { ThemeContext } from '../../module/ThemeManager';
import { Container } from '@mui/material';
import { HeroShimmer } from '../HeroShimmer';
import { GenreTagShimmer } from '../GenreTagShimmer';
import { VerticalCardShimmer } from '../VerticalCardShimmer';
import { SquareCardShimmer } from '../SquareCardShimmer';

const DiscoveryShimmer = () => {
    return (
        <ThemeContext.Consumer>
            {() => {
                return (
                    <Container
                        disableGutters
                        sx={{
                            width: '100%',
                            marginTop: { xs: '0', sm: '20px' },
                            marginLeft: { xs: '0px', sm: '65px', xl: '100px' },
                            paddingLeft: { xs: '16px', sm: '40px' },
                            paddingRight: { xs: '16px', sm: '40px' },
                            overflowX: 'hidden',
                        }}
                        maxWidth={false}>
                        <HeroShimmer />
                        <GenreTagShimmer />
                        <VerticalCardShimmer />
                        <SquareCardShimmer />
                    </Container>
                );
            }}
        </ThemeContext.Consumer>
    );
};

export { DiscoveryShimmer };
